export const SET_LOADED = 'APP/SET_LOADED';
export const SET_SIDEBAR_OPEN = 'APP/SET_SIDEBAR_OPEN';
export const SET_THEME_MODE = 'APP/SET_THEME_MODE';
